<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :pathResource="pathResource">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2" v-if="visibleColumnColsDate">
                        <label class="sa-label-data">NRE</label>
                        <b-form-input v-model="filtro.codiceBar2"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2" v-if="visibleColumnColsDate">
                        <label class="sa-label-data">Agenda</label>
                        <b-form-select v-model="filtro.idAgenda" @change="onChangeAgendaFiltro" :options="agendeOptions"
                            text-field="titolo" value-field="id"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2" v-if="visibleColumnColsDate">
                        <label class="sa-label-data">Prestazione</label>
                        <b-form-select v-model="filtro.prestazione" :options="agendaPrestazioniOptions"
                            text-field="descrizionePrestazione" value-field="codicePrestazione"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3" v-if="visibleColumnColsDate">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtro.dataRiferimentoDal" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3" v-if="visibleColumnColsDate">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtro.dataRiferimentoAl" format="DD-MM-YYYY" value-type="timestamp"
                            placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>

                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter")
                        }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <AccettazionePrestazioniListComponent ref="cmpAccettazionePrestazioneListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";

import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import AccettazionePrestazioniListComponent from "../../../accettazione/appuntamenti/components/AccettazionePrestazioniListComponent.vue";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        DatePicker,
        AccettazionePrestazioniListComponent
    },
    data() {
        return {
            idAccettazione: null,
            filtro: {
                dataRiferimentoDal: new Date().getTime(),
                dataRiferimentoAl: new Date().getTime(),
                codiceBar2: null,
                idAgenda: null,
                prestazione: null
            },
            agendeOptions: [],
            agendaPrestazioniOptions: [],
            btnNewVisible: true,
            pathResource: "/progettoriabilitativoindividuale",
            pathResourceAccettazione: "/accettazionessn",
            linkback: "/rsagestioneospiti",
            listKey: 0,
            visibleColumnColsDate: true,
            presidio: {},
            jsonData: { accettazione: { accettazioneAnagrafica: {} }, accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {}, ricette: [] },
            statiPriOptions: [],
        };
    },
    mounted() {
        this.setPresidio();
        this.idAccettazione = this.$route.query.idAccettazione;
        const unaSettimanaInMs = 7 * 24 * 60 * 60 * 1000;
        this.filtro.dataRiferimentoAl = this.filtro.dataRiferimentoDal + unaSettimanaInMs;
        this.loadAccettazione();
        this.loadAgende();

    },
    methods: {
        setPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        loadAccettazione() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.pathResourceAccettazione + "/" + this.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    this.jsonData = response.data.data;
                    this.setDatiAppuntamento();
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        setDatiAppuntamento() {
            let filter = {
                idPresidio: this.presidio.idPresidio,
                barcode: this.jsonData.accettazioneAnagrafica.identificativo,
                cf: this.jsonData.accettazioneAnagrafica.identificativo,
                dataRiferimentoDal: this.filtro.dataRiferimentoDal,
                dataRiferimentoAl: this.filtro.dataRiferimentoAl,
                codiceBar2: this.filtro.codiceBar2,
                idAgenda: this.filtro.idAgenda,
                prestazione: this.filtro.prestazione
            }
            this.$refs.cmpAccettazionePrestazioneListComponent.init(filter, null);

        },
        onSubmit() {
            this.setDatiAppuntamento();
        },
        onReset() {
            const unaSettimanaInMs = 7 * 24 * 60 * 60 * 1000;
            const oggi = new Date().getTime();
            this.filtro = {
                dataRiferimentoDal: oggi,
                dataRiferimentoAl: oggi + unaSettimanaInMs
            };

            this.setDatiAppuntamento();

        },
        loadAgende() {
            this.agendeOptions = [];
            this.loadDataResources("/agende", { idPresidio: this.presidio.idPresidio }, this.loadAgendeSuccess, this.loadAgendeError);
        },
        loadAgendeSuccess(response) {
            this.agendeOptions = response.data.data;
        },
        loadAgendeError(error) {
            console.log(error);
        },
        onChangeAgendaFiltro(id) {
            this.loadAgendePrestazioni(id)
        },

        loadAgendePrestazioni(id) {
            this.agendaPrestazioniOptions = [];
            this.loadDataResources("/agendaprestazioni?idAgenda=" + id, {}, this.loadAgendePrestazioniSuccess, this.loadAgendePrestazioniError);
        },
        loadAgendePrestazioniSuccess(response) {
            this.agendaPrestazioniOptions = response.data.data;
        },
        loadAgendePrestazioniError(error) {
            console.log(error);
        },
    },
};
</script>

<style></style>
